<div class="row p-b-10">
    <div class="col-md-12 col-lg-6">
        <h4 class="page-title m-b-5">{{TR "Vorschau"}}</h4>
        {{#if handle}}
        <div id="pdf-preview-container">
            <iframe src="/api/v1/devices/reports/{{id}}/preview.pdf?handle={{handle}}" id="pdf-preview" type="application/pdf">
            </iframe>
        </div>
        {{else}}
        <div class="alert alert-danger">{{TR 'Die Vorschau konnte nicht generiert werden.'}}</div>
        {{/if}}
    </div>
    <div class="col-md-12 col-lg-6">
        <h4 class="page-title m-b-5">{{TR "Inhalt"}}</h4>
        <div id="master"></div>
    </div>
</div>
